<template>
    <div id="app">
        <nav id="header" class="header3WithCursor" @click="scrollToId('Online-Termine')">
            <p style="line-height:120%">
                <b>
                    <font size="6">Hausarztpraxis am Osterberg</font>
                </b><br />
                <font size="3">seit Nov. 2023 in der Hindenburgstraße 3</font><br />

                <font color="#df9a50">Um lange <b>Wartezeiten in der Telefonwarteschleife zu vermeiden</b>, nutzen Sie bitte
                    gerne
                    die Möglichkeit
                    der <font color="#0000FF"><b>Online-Terminvergabe</b></font>
                </font>
            </p>
        </nav>
        <div id="welcome" class="container">
            <div class="bubble" @click="scrollToId('Praxis')">
                <picture>
                    <source loading="lazy" srcset="/Praxisteam_mittel.jpg" type="image/jpg" />
                    <img src="/fallback/Praxisteam.jpg" alt="" />
                </picture>

                <!--
                <picture>
                    <source loading="lazy" srcset="/kowollik.min.webp" type="image/webp" />
                    <img src="/fallback/kowollik.jpg" alt="" />
                </picture>
                -->
                <p>Praxisteam</p>
            </div>
            <div class="bubble" @click="scrollToId('Leistungsspektrum')">
                <picture>
                    <source loading="lazy" srcset="/pills.min.webp" type="image/webp" />
                    <img src="/fallback/pills.jpg" alt="" />
                </picture>
                <p>Leistungsspektrum</p>
            </div>
            <div class="bubble" @click="scrollToId('Online-Termine')">
                <picture>
                    <source loading="lazy" srcset="/dubidoc-screen_shot4.webp" type="image/webp" />
                    <img src="/fallback/dubidoc-screen_shot4.png" alt="" />
                </picture>
                <p>Online-Termine</p>
            </div>
            <div class="bubble" @click="scrollToId('Kontakt')">
                <picture>
                    <source loading="lazy" srcset="/Logo-HausAP-a-O.webp" type="image/webp" />
                    <img src="/fallback/Logo-HausAP-a-O.jpeg" alt="" />
                </picture>
                <p>Kontakt</p>
            </div>
            <div class="bubble" @click="scrollToId('Aktuelles')">
                <picture>
                    <source loading="lazy" srcset="/waterdrop.min.webp" type="image/webp" />
                    <img src="/fallback/waterdrop.jpg" alt="" />
                </picture>
                <p>Aktuelles</p>
            </div>
            <div class="bubble" @click="scrollToId('Links')">
                <picture>
                    <source loading="lazy" srcset="/flower.min.webp" type="image/webp" />
                    <img src="/fallback/flower.jpg" alt="" />
                </picture>
                <p>Links</p>
            </div>
        </div>
        <div id="Praxis" class="container">
            <h2 class="container-fluid h2">Praxisteam</h2>
            <div class="bubble tooltip0">
                <picture>
                    <source loading="lazy" srcset="/kowollik.min.webp" type="image/webp" />
                    <img src="/fallback/kowollik.jpg" alt="" />
                </picture>
                <p>Katharina Kowollik, Allgemeinärztin</p>
                <div class="bottom">
                    <p>Fachärztin für Allgemeinmedizin</p>
                    <i></i>
                </div>
            </div>
            <div class="cv">
                <h3>Zur Person</h3>
                <ul>
                    <li>1986 - 1993 Medizinstudium an der RWTH Aachen</li>
                    <li>
                        1994 - 2003 allgemeinmedizinische Weiterbildung in Bad
                        Fallingbostel, Celle und Walsrode
                    </li>
                    <li>2004 Facharztprüfung Allgemeinmedizin</li>
                    <li>2005 - 2009 Klinik Bad Fallingbostel</li>
                    <li>2009 - 2010 Heidekreisklinikum Walsrode</li>
                    <li>
                        2011 - 2020 angestellte Fachärztin, Liethwaldpraxis
                    </li>
                    <li>
                        April 2020 Übernahme der Praxis und Neugründung als
                        Hausarztpraxis am Liethwald
                    </li>
                    <li>
                        November 2023 Umzug der Praxisräume und Umbenennung in
                        Hausarztpraxis am Osterberg
                    </li>
                </ul>
            </div>
            <div class="Team">
                <div class="teammembers">
                    <div class="bubble tooltip">
                        <picture>
                            <source loading="lazy" srcset="/Mevius.webp" type="image/webp" />
                            <img src="/fallback/Mevius.jpeg" alt="" />
                        </picture>
                        <p>Dr. Iris Mevius, Allgemeinärztin</p>
                        <div class="bottom">
                            <p>Fachärztin für Allgemeinmedizin</p>
                            <i></i>
                        </div>
                    </div>
                    <div class="bubble tooltip">
                        <picture>
                            <source loading="lazy" srcset="/Ohlau.webp" type="image/webp" />
                            <img src="/fallback/Ohlau.jpg" alt="" />
                        </picture>
                        <p>Anke Ohlau, MFA</p>
                        <div class="bottom">
                            <p>
                                Praxisorganisation-Qualitätsmanagement-Wundmanagement
                            </p>
                            <i></i>
                        </div>
                    </div>
                    <div class="bubble tooltip">
                        <picture>
                            <source loading="lazy" srcset="/Jochmaring.webp" type="image/webp" />
                            <img src="/fallback/Jochmaring.jpg" alt="" />
                        </picture>
                        <p>Silke Jochmaring, MFA</p>
                        <div class="bottom">
                            <p>
                                Medizinische Fachangestellte-Hygienebeauftragte
                            </p>
                            <i></i>
                        </div>
                    </div>
                    <div class="bubble tooltip">
                        <picture>
                            <source loading="lazy" srcset="/IMG_6760-Tanja-Web-klein.jpeg" type="image/webp" />
                            <img src="/fallback/IMG_6760-Tanja-Web-klein.jpeg" alt="" />
                        </picture>
                        <p>Tanja Röttjer, MFA</p>
                        <div class="bottom">
                            <p>Medizinische Fachangestellte</p>
                            <i></i>
                        </div>
                    </div>
                    <div class="bubble tooltip">
                        <picture>
                            <source loading="lazy" srcset="/Tabea-WedemannWebKlein.webp" type="image/webp" />
                            <img src="/fallback/Tabea-WedemannWebKlein.jpg" alt="" />
                        </picture>
                        <p>Tabea Wedemann, MFA</p>
                        <div class="bottom">
                            <p>Medizinische Fachangestellte</p>
                            <i></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="Leistungsspektrum" class="container container-fluid">
            <h2 class="h2 container-fluid">Leistungsspektrum</h2>
            <div id="Leistungen">
                <h3>Unsere Leistungen</h3>
                <ul>
                    <li>Laboruntersuchungen</li>
                    <li>Ultraschalluntersuchung</li>
                    <li>EKG</li>
                    <li>Langzeit EKG</li>
                    <li>Langzeit Blutdruck</li>
                    <li>Lungenfunktion</li>
                    <li>Impfungen</li>
                    <li>Kindervorsorgeuntersuchungen U3-U9 sowie J1</li>
                    <li>Gesundheits-Vorsorgeuntersuchungen (ab 35 Jahren)</li>
                    <li>Hautkrebsscreening</li>
                    <li>Hirnleistungstests</li>
                    <li>DMP (Diabetes, COPD, Asthma und KHK)</li>
                    <li>Hausarztmodelle aller Krankenkassen</li>
                    <li>
                        in medizinisch begründeten Fällen Hausarztbesuche und
                        häusliche Betreuung von Senioren
                    </li>
                    <li>Betreuung im Senioren- und Pflegeheim</li>
                </ul>
            </div>
            <div id="Wahlleistungen">
                <h3>Unsere Wahlleistungen</h3>
                <ul>
                    <li>Beratung zu Reisen und Impfungen</li>
                    <li>Versicherungsanfragen und Bescheinigungen</li>
                    <li>Wunsch- Laborleistungen</li>
                    <li>Vitamin-Aufbau-Spritzen</li>
                    <li>Patientenverfügung</li>
                    <li>Führerschein Tauglichkeitsuntersuchung</li>
                    <li>Sportuntersuchung</li>
                </ul>
            </div>
        </div>
        <div id="Online-Termine" class="container">
            <h2>Online-Termine: Terminvergabe online über Dubidoc</h2>
            <div class="container">
                <ul>
                    <h3>Online-Terminarten</h3>
                    <div>
                        <p>
                            Eine Online-Terminbuchung ist ab sofort für folgende Terminarten möglich:<br><br>
                        </p>
                        <div>
                        </div>
                        <p>
                            <b>Kurztermine</b> (außer Infekte) für ein akutes Anliegen wie z.B.
                            Krankschreibung (außer Infekt!), kurze
                            Untersuchung etc.
                        </p>
                        <p>
                            täglich 11:00 - 12:00 Uhr<br><br>
                        </p>
                        <p>
                            <b>Sprechstunde</b> für normale Untersuchungen und Beratungen. 15 Minuten Zeitvorgabe, bei
                            längerem Gesprächsbedarf bitte Terminart 'Gespräch/Antrag' wählen.<br><br>
                        </p>
                        <p>
                            <b>Gespräch/ Antrag:</b> 20 Minuten Zeit für Anträge (z.B. Reha) oder psych. Gespräch.<br><br>
                        </p>
                        <p>
                            <b>Impfungen</b> (außer Corona) für Kinder ab 10 Jahren und Erwachsene: Bitte bringen
                            Sie Ihren Impfpass und Ihre Versichertenkarte
                            mit.<br><br>
                        </p>

                        <p>
                            <b>Infektsprechstunde</b>: Zum Schutz unseres Personals tragen Sie bitte in unseren
                            Praxisräumen eine <font color="FF0000">FFP2-Maske</font>!
                        </p>
                        <p>
                            täglich 12:00 - 12:30 Uhr<br><br>
                        </p>
                        <p>
                            <b>Blutentnahmen</b>: Bitte kommen Sie nüchtern! Bei Kontrolle der Schilddrüsenwerte
                            keine Tabletten einnehmen!
                        </p>
                        <p>
                            täglich 7:40 - 12:00 Uhr<br><br>
                        </p>

                        <p>
                            Für <b>Gesundheitsvorsorgen, Kinder-Vorsorgen, Impfungen von Kindern unter 10 Jahren und weitere
                                Anliegen</b> melden Sie sich bitte telefonisch.<br><br>
                        </p>
                    </div>
                    <h3>Link zur Online-Terminvergabe</h3>
                    <a href="https://www.dubidoc.de/praxiscode/60050">
                        <font color="#0000FF" size="6">Hier geht es zum Terminportal</font>
                    </a>
                    <li>
                        <div>
                            <p>
                                Angaben für den manuellen Seitenaufruf: dubidoc.de/praxiscode/60050
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div id="Kontakt" class="container container-fluid">
            <div class="kontakt-container">
                <h2 class="h2 container-fluid">Kontakt</h2>
                <p>Hausarztpraxis am Osterberg</p>
                <p>Katharina Kowollik - Fachärztin für Allgemeinmedizin</p>
                <p>Hindenburgstraße 3</p>
                <p>29683 Bad Fallingbostel</p>
                <p>
                    <a href="mailto:info@hausarztpraxis-am-Osterberg.de">Email: info@hausarztpraxis-am-osterberg.de</a>
                </p>
                <p><a href="tel:0516298900">Tel: 05162 9890-0</a></p>
                <p>Fax: 05162 9890-15</p>
            </div>
        </div>
        <div id="Sprechzeiten" class="container">
            <h2>Unsere Öffnungszeiten</h2>
            <div class="container">
                <ul>
                    <li>
                        <h3>Öffnungszeiten</h3>
                        <div>
                            <table>
                                <tr>
                                    <td>Montag - Freitag</td>
                                    <td>7:40-12:30 Uhr</td>
                                </tr>
                                <tr>
                                    <td>Montag, Dienstag und Donnerstag</td>
                                    <td>16:00- 18:00 Uhr</td>
                                </tr>
                            </table>
                        </div>
                    </li>
                    <li>
                        <h3>Sprechzeiten</h3>
                        <div>
                            <table>
                                <tr>
                                    <td>Montag, Donnerstag und Freitag</td>
                                    <td>8:00 - 12:30 Uhr</td>
                                </tr>
                                <tr>
                                    <td>Dienstag und Mittwoch</td>
                                    <td>8:00 - 13:00 Uhr</td>
                                </tr>
                                <tr>
                                    <td>Montag und Donnerstag</td>
                                    <td>16:00 - 18:00 Uhr</td>
                                </tr>
                            </table>
                        </div>
                    </li>

                    <li>
                        <!--        <h3 class="corona">Aufgrund von Covid-19</h3> -->
                        <!-- <h3 class="corona">Terminhinweis</h3> -->
                        <div class="corona">
                            <p>
                                Vereinbaren Sie bitte telefonisch oder online einen Termin, um lange Wartezeiten zu
                                vermeiden.
                            </p>
                        </div>
                    </li>

                    <li>
                        <h3>Rezeptbestellungen</h3>
                        <div>
                            <p>
                                Bitte nutzen Sie unser Rezepttelefon</p>
                            <p>
                                <a href="tel:0516298900">05162 9890-0 und anschließend die "1" drücken</a>&nbsp;
                            </p>
                            <p>
                                oder schreiben Sie uns eine Email an
                            </p>
                            <p><a href="mailto:rezept@hausarztpraxis-am-osterberg.de">rezept@hausarztpraxis-am-osterberg.de</a>
                            </p>
                        </div>
                    </li>
                    <li>
                        <h3>Blutentnahmen und Impfungen</h3>
                        <div>
                            <p>
                                Zur Vermeidung von längeren Wartezeiten
                                vereinbaren Sie bitte einen Termin
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div id="Aktuelles" class="container container-fluid">
            <h2 class="h2 container-fluid">Aktuelles</h2>
            <div>
                <div class="news">
                    <span class="date">8.11.2025</span>
                    <p>
                        Als langfristige Verstärkung unseres Praxisteams suchen wir <b>Dich</b>:
                    </p>

                    <b>
                        <font color="FF0000">Auszubildende:r ab Sommer 2026!</font>

                    </b>

                    <p>
                        Sprich uns gerne an, wir freuen uns auf Deine Bewerbung.
                    </p>

                </div>
                <div class="news">
                    <span class="date">16.10.2023</span>
                    <p>
                        Unsere Praxis zieht Anfang November um!
                    </p>
                    <p>
                        Für den Umzug schließen wir ab dem 3. Nov. die Praxisräume in der Soltauer Straße 33.
                    </p>
                    <p>
                        Ab dem <b>13. November begrüßen wir Sie gerne mit unverändertem Team in den neuen Praxisräumen der
                            Hausarztpraxis am Osterberg in der Hindenburgstraße 3.
                            <p>
                                <font color="FF0000">Die
                                    Telefonnummern bleiben gleich!</font>
                            </p>
                        </b>
                    </p>
                    <p>
                        Die Adresse der aktuellen Homepage lautet https://hausarztpraxis-am-osterberg.de
                    </p>
                </div>
                <div class="news">
                    <span class="date">01.07.2023</span>
                    <p>
                        Unsere Praxis zieht bald um!
                    </p>
                    <p>
                        Voraussichtlich im 4. Quartal 2023 werden wir unsere neuen und frisch renovierten Praxisräume in der
                        Hindenburgstraße 3 in Bad Fallingbostel beziehen. Ein genaues Datum wird rechtzeitig bekannt gegeben
                        werden.
                    </p>
                </div>
                <div class="news">
                    <span class="date">01.07.2023</span>
                    <p>
                        Wir freuen uns, dass Frau Tabea Wedemann im Juni Ihre Ausbildung zur Medizinischen Fachangestellten
                        erfolgreich beendet hat und weiterhin in unserem Team tätig ist.
                    </p>
                </div>

                <div class="news">
                    <span class="date">01.05.2023</span>
                    <p>
                        Zum 1. Mai haben wir unsere langjährige MFA Frau Helga Senhen in den wohlverdienten Ruhestand
                        verabschiedet.
                    </p>
                </div>

                <div class="news">
                    <span class="date">08.04.2023</span>
                    <p>
                        Ab dem 8. April 2023 sind alle geltenden Corona Verordnungen aufgehoben. Das bedeutet:
                    </p>
                    <p>
                        - ab sofort keine Maskenpflicht mehr in medizinischen Einrichtungen
                    </p>
                    <p>
                        - keine telefonische Krankschreibung bei Infektion mehr möglich, Sie müssen also wieder persönlich
                        in der Praxis erscheinen (beachten Sie bitte die Zeiten der Infektsprechstunde)
                    </p>
                </div>
                <div class="news">
                    <span class="date" @click="scrollToId('Online-Termine')">20.02.2023</span>
                    <p @click="scrollToId('Online-Termine')">
                        Ab sofort können Sie auch online Termine vereinbaren. Details dazu finden Sie in dem
                        entsprechenden neuen Bereich auf unserer Homepage: <b>
                            <font color="#0000FF">Online-Termine</font>
                        </b>
                    </p>
                </div>
                <!--
                <div class="news">
                    <span class="date">22.02.2022</span>
                    <p>
                        Wir haben die Probleme mit der Telefonanlage
                        <b>behoben.
                        </b>
                        Mit der
                        <b>neuen Telefonanalgentechnik können Sie uns nun noch
                            besser
                        </b>
                        erreichen.
                    </p>
                </div>
              
                <div class="news">
                    <span class="date">11.02.2022</span>
                    <p>
                        Bitte beachten Sie, dass wir zur Zeit Probleme mit der Telefonanlage haben. Wir arbeiten mit
                        Hochdruck an der Lösung, doch
                        kommt es leider in unregelmäßigen Abständen dazu, dass keine Anrufe durchgestellt werden.
                    </p>
                    <p>Wir danken für Ihr Verständnis.</p>
                </div>
                <div class="news">
                    <span class="date">20.12.2021</span>
                    <p>
                        Bitte beachten Sie, dass
                        <b>der Zutritt zur Praxis ab sofort
                        </b>
                        nur noch mit
                        <b>FFP2-Maske
                        </b> gestattet
                        ist.
                    </p>
                    <p>
                        Diese Regelung dient dem Gesundheitsschutz aller
                        Patienten und unseres Praxisteams.
                    </p>
                    <p>Wir danken für Ihr Verständnis.</p>
                </div>
                <div class="news">
                    <span class="date">13.12.2021</span>
                    <p>
                        Wir führen <b>Erst-, Zweit- und Boosterimpfungen</b> mit
                        Biontech- und Moderna-Impfstoff durch (je nach
                        Verfügbarkeit). Aufgrund der beschränkten Kapazitäten
                        und Ressourcen impfen wir jedoch
                        <b>nur Bestandspatienten</b>.
                    </p>

                    <p>
                        Anmeldung bitte per Email an
                        <a href="mailto:rezept@hausarztpraxis-am-Osterberg.de">rezept@hausarztpraxis-am-Osterberg.de</a>,
                        wir vergeben dann einen Termin. Bitte stellen Sie
                        sich auf Wartezeiten von bis zu 8 Wochen ein.
                    </p>
                    <p>
                        Bitte drucken Sie für die Erst- und Zweitimpfung den
                        Anamnese-/ Aufklärungs- und Einverständnisbogen (s.
                        unten) aus und bringen Sie diese
                        <b>ausgefüllt</b> zusammen mit Ihrem
                        <b>Impfausweis</b> und Ihrer
                        <b>Versichertenkarte</b> zum Impftermin mit.
                    </p>
                    <p>
                        Alternativ können Sie sich auch gerne einen Impftermin
                        im Heidekreisklinikum Walsrode vereinbaren. Hier geht es
                        zum entsprechenden Terminportal:
                    </p>
                    <p>
                        <a href="https://veranstaltungen.heidekreis.de">
                            <font color="#0000FF">Terminportal Heidekreis</font>
                        </a>
                    </p>
                    <br />
                </div>
                <div class="news">
                    <span class="date">04.08.2021</span>
                    <p>
                        <font color="FF0000"><b>Richtigstellung</b></font>
                    </p>
                    <p>Liebe Patientinnen und Patienten.</p>
                    <p>
                        Leider wurde unsere Praxis anonym beim Gesundheitsamt
                        Walsrode mit falschen Behauptungen diskreditiert, was
                        das gesamte Praxisteam sehr betroffen macht!
                    </p>

                    <p>
                        Wir möchten hiermit klarstellen, dass wissentlich
                        niemals infektiöse Patienten (Verdacht auf COVID-19) mit
                        gesunden Patienten im Wartezimmer zusammengesessen
                        haben. Wir achten schon bei der telefonischen und/oder
                        persönlichen Anmeldung darauf, dass nur gesunde
                        Patienten das Wartezimmer betreten und haben aus diesem
                        Grund seit Beginn der Pandemie eine tägliche
                        Infektsprechstunde eingerichtet.
                    </p>
                    <p>
                        Es kommt jedoch vor, dass gesunde Patienten, die für
                        Urlaubsreisen, stationäre REHAs, ambulante oder
                        stationäre Eingriffe einen PCR Abstrich benötigen, im
                        Wartezimmer auf ihren Test warten. Das ist aus
                        hygienischer und infektiologischer Sicht völlig
                        unbedenklich.
                    </p>
                    <p>
                        Bitte sprechen Sie uns gerne an, wenn Sie Fragen haben.
                    </p>
                </div>
                -->
                <div class="news">
                    <span class="date">01.07.2021</span>
                    <p>
                        Tanja Röttjer verstärkt als Medizinische Fachangestellte
                        das Praxisteam.
                    </p>
                </div>
                <!--
                <div class="news">
                    <span class="date">07.06.2021</span>
                    <p>Unsere <b>Warteliste</b> für die COVID-19 Impfung
                        ist ab sofort wieder
                        <b>für unsere in der Praxis bekannten Patienten</b>
                        geöffnet!
                    </p>
                    
                                                    <p>
                                                        Entsprechend der Empfehlungen der STIKO impfen wir zur
                                                        Zeit grundsätzlich
                                                        <font color="FF0000"
                                                            ><b>keine</b> Kinder und Jugendlichen</font
                                                        >.
                                                    </p>
                                                    
                    <p>
                        Wir impfen zur Zeit grundsätzlich <b>keine</b> Kinder und Jugendlichen.
                    </p>
                    <p>
                        Bitte melden Sie sich
                        <b>ausschließlich per Email</b> bei
                        <a href="mailto:info@hausarztpraxis-am-Osterberg.de">info@hausarztpraxis-am-Osterberg.de</a>
                        an.
                    </p>

                    <p>Wir melden uns dann zwecks Terminvergabe bei Ihnen.</p>
                </div>
            -->

                <div class="news">
                    <span class="date">01.08.2020</span>
                    <p>
                        Tabea Wedemann verstärkt als Auszubildende das
                        Praxisteam.
                    </p>
                </div>
                <div class="news">
                    <span class="date">01.06.2020</span>
                    <p>
                        Frau Dr. Iris Mevius verstärkt als angestellte
                        Fachärztin für Allgemeinmedizin das Praxisteam.
                    </p>
                </div>
                <!--
                <div class="news">
                    <span class="date">04.04.2020</span>
                    <p>
                        Wir haben eine neue Webseite, schauen Sie sich doch mal
                        um.
                    </p>
                </div>
                -->
                <div class="news">
                    <span class="date">01.04.2020</span>
                    <p>
                        Hausärztin Katharina Kowollik hat die Hausarztpraxis am
                        Liethwald von Herrn Dr. Winkelmann übernommen.
                    </p>
                </div>
                <!--
                <div class="news">
                    <span class="date">20.03.2020</span>
                    <p>
                        Wir haben ein paar Leitfäden zu COVID-19 hochgeladen,
                        schauen Sie doch bei den Links mal rein.
                    </p>
                </div>
            -->
            </div>
        </div>
        <div id="Links" class="container">
            <h2 class="h2">Links</h2>
            <div class="container">
                <ul>
                    <!--
                    <li>
                        <a href="https://veranstaltungen.heidekreis.de">
                            <font color="#0000FF">Hier geht es zum Terminportal des Landkreis
                                Heidekreis für Coronaimpfungen</font>
                        </a>
                    </li>
                -->
                    <br />
                    <li>
                        <font color="FF0000">COVID-19 Impfung in unserer Praxis:</font><br /><br />Wenn Sie bei uns
                        einen
                        <b>bestätigten</b> Impftermin haben, drucken Sie bitte
                        die folgenden <b>2 Formulare</b> aus oder holen Sie sie in der
                        Praxis ab.<br /><b>Lesen Sie die Formulare zu Hause in Ruhe durch</b>
                        und
                        <b>bringen Sie diese <font color="FF0000">ausgefüllt</font> zum Impftermin mit</b>.
                    </li>

                    <li>



                        <a
                            href="https://www.rki.de/DE/Content/Infekt/Impfen/Materialien/Downloads-COVID-19/Einwilligung-de.pdf?__blob=publicationFile">
                            <font color="#0000FF"><b>Anamneseformular</b> und
                                <b>Einwilligungserklärung</b>
                            </font>
                        </a>
                        <br />
                        <br />
                        <br />
                    </li>
                    <!--
                    <li>
                        <a href="/Hygienekonzept HAP am Osterberg.pdf">Hygienekonzept Hausarztpraxis am Osterberg</a>
                    </li>
                    <br />
                -->
                    <li>
                        <a href="/Fieberhafer_Infekt_Pat_Info.pdf">
                            <font color="#0000FF">Fieberhafter Infekt Patienteninformation</font>
                        </a>
                    </li>
                    <!--
                    <li>
                        <a href="/COVID19_HOME_CARE.pdf">COVID-19 Home Care Handlungsanweisung</a>
                    </li>
                    <li>
                        <a
                            href="https://cdn.hausarzt.digital/wp-content/uploads/2020/04/Coronavirus_Patinfo-gesund_2104.pdf">Coronavirus
                            Patienteninformationen</a>
                    </li>
                  
                    <li>
                        <a href="https://cdn.hausarzt.digital/wp-content/uploads/2020/04/Coronavirus_Factsheet_1704.pdf">Coronavirus
                            Factsheet</a>
                    </li>
                    <li>
                        <a
                            href="https://cdn.hausarzt.digital/wp-content/uploads/2020/03/N%C3%A4hanleitung-f%C3%BCr-Mund-Nasen-Schutz.pdf">Nähanleitung
                            für Behelf-Mund-Nasen-Schutz</a>
                    </li>
                    <li>
                        <a
                            href="https://cdn.hausarzt.digital/wp-content/uploads/2020/04/Coronavirus_Patinfo_Psyche_allgemein_2204.pdf">Ratgeber
                            zur Isolation</a>
                    </li>
                    <li>
                        <a
                            href="https://cdn.hausarzt.digital/wp-content/uploads/2020/05/Coronavirus_Patinfo_Antikoerper_1105n.pdf">Ratgeber
                            Antikörpertest</a>
                    </li>
                    -->
                </ul>
            </div>
        </div>
        <div id="Rechtliches">
            <h2>Rechtliches</h2>
            <div class="container">
                <a class="disabled">Home</a>
                <a href="datenschutzerklärung.html">Datenschutzerklärung</a>
                <a href="impressum.html">Impressum</a>
            </div>
        </div>
        <div class="scrollButton">
            <svg v-show="isScrolled" width="2rem" height="2rem" viewBox="0 0 88 88" @click="scrollToId('welcome')">
                <circle cx="44" cy="44" r="40" stroke="##70bdb5" fill="#70bdb5" stroke-width="4" />
                <line x1="44" y1="16" x2="44" y2="72" style="stroke: #fff; stroke-width: 12" />
                <line x1="16" y1="48" x2="44" y2="16" style="stroke: #fff; stroke-width: 12" />
                <line x1="72" y1="48" x2="44" y2="16" style="stroke: #fff; stroke-width: 12" />
                <circle cx="44" cy="16" r="6" fill="white" />
                <circle cx="16" cy="48" r="6" fill="white" />
                <circle cx="72" cy="48" r="6" fill="white" />
                <circle cx="44" cy="72" r="6" fill="white" />
            </svg>
        </div>
        <Banner />
    </div>
</template>

<script>
import Banner from "./components/banner.vue";

export default {
    name: "App",
    components: {
        Banner,
    },
    data: function () {
        return {
            isScrolled: false,
        };
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        scrollToId: function (id) {
            window.scroll({
                top:
                    // These magic numbers are the total height of the navbar, maybe I should replace them with something more readable
                    document.getElementById(id).offsetTop -
                    (1.5 + 2 * 2.5) * 16,
                left: 0,
                behavior: "smooth",
            });
        },
        handleScroll: function () {
            if (window.pageYOffset > window.innerHeight * 0.5) {
                this.isScrolled = true;
                return true;
            }
            this.isScrolled = false;
            return false;
        },
    },
};
</script>

<style lang="scss">
@import url("/fonts/montserrat.css");
@import "./palette";

body {
    margin: 0;
    line-height: 1;
    scroll-behavior: smooth;

    #app {
        font-family: "Montserrat", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        margin: 0 0 0 0;
        box-sizing: border-box;
        padding: 0;

        .bubble {
            img {
                clip-path: circle(50%);
                max-height: 100%;
                max-width: 100%;
            }

            p {
                margin: 0;
                padding-top: 0.2rem;
                font-size: 1.5rem;
            }

            height: 40em;
            cursor: pointer;
        }

        .topArea {
            p {
                margin: 0;
                padding-top: 0.2rem;
                font-size: 1.5rem;
            }

            cursor: pointer;
        }

        .h2 {
            font-size: 2rem;
        }

        a {
            text-decoration: none;
        }

        a:visited {
            color: #000;
        }

        .header {
            font-size: 1.5rem;
            background-color: $dark_blue;
            color: $snow_white;
            padding: 1.5rem;
            position: sticky;
            top: 0;
            z-index: 100;
        }

        .header2 {
            font-size: 1.0rem;
            background-color: LightGray;
            color: $snow_white;
            padding: 0.5rem;
            position: sticky;
            top: 0;
            z-index: 100;
        }

        .header3WithCursor {
            font-size: 1.5rem;
            background-color: LightGray;
            color: $snow_white;
            position: sticky;
            top: 0;
            z-index: 100;
            line-height: 1.1;
            cursor: pointer;
        }

        .disabled {
            cursor: not-allowed;
            opacity: 0.5;
            text-decoration: none !important;
        }

        .container {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            padding-bottom: 2rem;
        }

        .container {
            .bubble {
                padding: 1.5rem;
                height: 20em;
            }
        }

        #welcome {
            min-height: calc(100vh - (1.5rem * 2 + 2.5rem));
            color: #000;

            a {
                color: #000;
            }
        }

        #Praxis {
            background-color: #ededed;
            margin-top: 2rem;
            display: grid !important;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: min-content 1fr 1fr min-content;
            grid-template-areas:
                "header header"
                "photo photo"
                "text text"
                "team team";

            h2 {
                grid-area: header;
                margin: 0;
                padding: 1rem 0;
            }

            .bubble {
                grid-area: photo;
                padding-bottom: 2.5em;
            }

            .cv {
                grid-area: text;
                text-align: left;
                padding: 0 2rem 0 2rem;
                line-height: 1.4;

                ul {
                    padding-left: 0;
                }
            }

            .Team {
                grid-area: team;
                padding: 0 2em;

                .teammembers {
                    display: flex;
                    justify-content: space-evenly;
                    flex-direction: column;
                    flex-wrap: wrap;

                    .bubble {
                        img {
                            clip-path: circle(37.77% at 120px 108px);
                            height: 110%;
                        }

                        p {
                            font-size: 1em;
                        }
                    }
                }
            }
        }

        @media screen and (min-width: 885px) {
            .Team .teammembers {
                flex-direction: row !important;
            }
        }

        #Leistungsspektrum {
            flex-direction: row;
            text-align: center;
            align-items: start;
            justify-content: start;
            width: 90%;
            margin: 0 auto;

            div {
                text-align: left;
            }

            #Leistungen {
                text-align: left;
                padding: 2em;
            }

            #Wahlleistungen {
                text-align: left;
                margin: 0 auto auto 0;
                padding: 2em;
            }

            ul {
                text-align: left;
                margin-left: 0;
                padding-left: 1em;
                line-height: 1.2em;
            }
        }

        #Kontakt {
            background-image: url("/iphone.min.webp");
            background-size: cover;
            background-repeat: no-repeat;
            background-attachment: fixed;
            /*color: $snow_white;*/
            color: #000;
            flex-flow: column;
            flex-wrap: wrap;

            h2 {
                font-size: 2rem;
            }

            h3 {
                margin-top: 2em;
            }

            a {
                text-decoration: none;
                /* color: $snow_white; */
                color: #000;
            }

            a:visited {
                /* color: $snow_white; */
                color: #000;
            }

            .kontakt-container {
                background-color: #ece9e2;
                opacity: 0.75;
                border-radius: 5px;
                color: #000;
                margin: 2rem 2rem 0 2rem;
                padding: 2rem;
            }
        }

        #Sprechzeiten {
            background-image: url("/door.min.webp");
            background-attachment: fixed;
            background-size: cover;
            background-repeat: no-repeat;

            flex-direction: column;

            ul {
                padding: 0;
                margin: 0;
            }

            li {
                list-style: none;
            }

            table {
                text-align: left;
            }

            .container {
                flex-direction: column;
                background-color: #ece9e2;
                border-radius: 5px;
                opacity: 0.75;
                margin: 2rem 2rem 0 2rem;
                padding: 2rem;

                li {
                    max-width: 80vw;
                }
            }

            a {
                cursor: pointer;
                text-decoration: underline;
                color: #000;
            }

            .corona {
                color: red;
                font-weight: bold;
            }
        }

        #Online-Termine {
            background-image: url("/door.min.webp");
            background-attachment: fixed;
            background-size: cover;
            background-repeat: no-repeat;

            flex-direction: column;

            ul {
                padding: 0;
                margin: 0;
            }

            li {
                list-style: none;
            }

            table {
                text-align: left;
            }

            .container {
                flex-direction: column;
                background-color: #ece9e2;
                border-radius: 5px;
                opacity: 0.75;
                margin: 2rem 2rem 0 2rem;
                padding: 2rem;

                li {
                    max-width: 80vw;
                }
            }

            a {
                cursor: pointer;
                text-decoration: underline;
                color: #000;
            }

            .corona {
                color: red;
                font-weight: bold;
            }
        }


        @media screen and (min-width: 930px) {
            #Leistungsspektrum {
                div {
                    max-width: 40vw;
                }
            }

            #Praxis {
                grid-template-areas:
                    "header header"
                    "photo text"
                    "photo text"
                    "team team";

                .cv {
                    padding: 0;

                    ul {
                        list-style: none;
                    }
                }

                .bubble p {
                    font-size: 1rem;
                }
            }

            #Sprechzeiten {
                .container {
                    width: 30vw;
                }
            }
        }

        #Aktuelles {
            background-attachment: fixed;
            background-image: url("/flower_in_water.min.webp");
            background-size: cover;
            background-repeat: no-repeat;

            div {
                .news {
                    background-color: #ededed;
                    opacity: 0.75;
                    border-radius: 0.25rem;
                    padding: 0.5rem;
                    max-width: max-content;
                    min-width: 80vw;
                    margin: 0.5rem 2rem;

                    span {
                        text-decoration: underline;
                    }
                }

                .newsRed {
                    color: red;
                    font-weight: bold;
                    background-color: #ededed;
                    opacity: 0.75;
                    border-radius: 0.25rem;
                    padding: 0.5rem;
                    max-width: max-content;
                    min-width: 80vw;
                    margin: 0.5rem 2rem;

                    span {
                        text-decoration: underline;
                    }
                }
            }
        }

        #Links {
            padding: 0 2em;
            flex-wrap: wrap;
            flex-direction: column;

            div {
                text-align: left;

                li {
                    margin: 0.5em 0;
                }
            }
        }

        #Rechtliches {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            background-color: #d1d1d1;

            a {
                padding: 0.5em;
                color: black;
                text-decoration: underline;
            }

            a:visited {
                color: black;
            }
        }

        .container-fluid {
            width: 100%;
        }

        .scrollButton {
            position: fixed;
            right: 2%;
            top: 91%;
        }
    }
}

/*Auto generated css for the tooltips*/
.tooltip {
    display: inline-block;
    position: relative;
    border-bottom: 1px dotted #666;
    /*text-align:left;*/
}

.tooltip .bottom {
    min-width: 200px;
    top: 250px;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 10px 20px;
    color: #eeeeee;
    background-color: #111111;
    font-weight: normal;
    font-size: 13px;
    border-radius: 8px;
    position: absolute;
    z-index: 99;
    box-sizing: border-box;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.8s;
}

.tooltip:hover .bottom {
    visibility: visible;
    opacity: 1;
}

.tooltip .bottom i {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -12px;
    width: 24px;
    height: 12px;
    overflow: hidden;
}

.tooltip .bottom i::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    left: 50%;
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: #111111;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

/*Auto generated css for the tooltips*/
/* ohne gestrichelte Linie unten drunter , Martin Kowollik, 24.2.2021 */
.tooltip0 {
    display: inline-block;
    position: relative;
    /*border-bottom: 1px dotted #666;*/
    /*text-align:left;*/
}

.tooltip0 .bottom {
    min-width: 200px;
    top: 250px;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 10px 20px;
    color: #eeeeee;
    background-color: #111111;
    font-weight: normal;
    font-size: 13px;
    border-radius: 8px;
    position: absolute;
    z-index: 99;
    box-sizing: border-box;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.8s;
}

.tooltip0:hover .bottom {
    visibility: visible;
    opacity: 1;
}

.tooltip0 .bottom i {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -12px;
    width: 24px;
    height: 12px;
    overflow: hidden;
}

.tooltip0 .bottom i::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    left: 50%;
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: #111111;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}</style>
